import styled from "styled-components";
export const StyledAvatar = styled.div `
  height: 2.5rem;
  width: 2.5rem;
  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
    width: 2.75rem;
  }
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.0625rem solid
    rgba(${({ theme }) => theme.colors.transparentBlack}, 0);
  ${({ disabled, isTab, theme }) => !disabled && !isTab
    ? `&:hover {
        cursor: pointer;
        border: 0.0625rem solid ${theme.colors.white};
        img {
          border: 0.0625rem solid rgba(${theme.colors.transparentBlack}, 0);
        }
      }
      &:active {
        background-color: ${theme.colors.black};
        @media ${theme.device.touch}{ background-color: rgba(${theme.colors.transparentBlack}, 0)};
        img {
          border: 0.0625rem solid ${theme.colors.grey15};
        }
      }`
    : ""};
  ${({ selected, theme, disabled }) => selected && !disabled
    ? `background-color: rgba(${theme.colors.transparentBlack}, 0.14);
    img {
      border: 0.0625rem solid ${theme.colors.black};
    }
    `
    : ""};
`;
export const StyledImageWrapper = styled.div `
  img {
    height: 1.875rem;
    width: 1.875rem;
    border-radius: 50%;
    border: 0.0625rem solid
      rgba(${({ theme }) => theme.colors.transparentBlack}, 0);
    filter: ${({ disabled }) => (disabled ? `grayscale(1)` : "")};
  }
`;
export const StyledInitials = styled.div `
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  justify-content: center;
  &&& button {
    justify-content: center;
    ${({ theme, disabled }) => disabled
    ? `background-color: rgba(${theme.colors.black},0.8);`
    : `
    color: ${theme.colors.grey15};
    `};
    ${({ theme, disabled, isTab }) => !disabled && !isTab
    ? ` &:active {
      color: ${theme.colors.white};
      > div {
        border: 0.0625rem solid ${theme.colors.white};
        &:hover > label {
          cursor:pointer;
        }
      }
    }`
    : ""};
    ${({ selected, theme, disabled }) => selected && !disabled
    ? `color: ${theme.colors.black};   > div {
      border: 0.0625rem solid rgba(${theme.colors.black},0.4);
    }`
    : ""};
  }
`;
export const StyledInitialsLabel = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 1.875rem;
  width: 1.875rem;
  background-color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.08);
  border: 0.0625rem solid
    rgba(${({ theme }) => theme.colors.transparentBlack}, 0.2);
`;
export const StyledIcon = styled.div `
  > button > span {
    height: 2rem;
    width: 2rem;
    min-width: 2rem;
  }
`;
